define('controllers/accountsummary',['require','johngrid','daterangepicker','layout','utils'],function(require) {
	var CreateJohnGrid = require('johngrid');
	require('daterangepicker');
	var layout = require('layout');
    var utils = require('utils');
	var accountSummaryController = {				
	    load: function() {
	        function init(hashQuerystring, data, state) {
	            //if they have no accounts or any unverified accounts, indicate that some transactions won't be displayed
	            var noVerifiedLink = $('#noVerifiedLink');
	            var accounts = window.ServerData.user.status.accounts;
	            if (
                    accounts.ActiveAccounts === 0 ||
                    accounts.NotReadyForVerification > 0 ||
                    accounts.ReadyForVerification > 0 ||
                    accounts.FailedTransactions
                ) {
	                noVerifiedLink.show();
	            } else {
	                noVerifiedLink.hide();
	            }

	            var showPerfectSaver = utils.querystring('t', hashQuerystring) === 'ps';
                //todo: show active tab...
	            var PaymentType = window.ServerData.feData.PaymentType; //extract from fedata...


	            //tabs
	            var tabCacher = {
	                loadedOneTimes: false,
	                loadedGoals: false,
	                loadedTransactions: false,
	                loadTab: function (loaded, grid, initFunc) {
	                    if (!loaded) {
	                        initFunc();
	                        grid.databind();
	                    }
	                }
	            };
	            $("form").on("submit", function (e) { e.preventDefault(); }); //key up in search causes page refresh, since it submits form
	            $('#account_tabs a').on("click", function (e) {
	                e.preventDefault();
	                var $this = $(this),
                        tab = $this.attr("href");

	                $this.tab('show');

	                switch (tab) {
	                    case "#ContentACHOneTimes":
	                        tabCacher.loadTab(tabCacher.loadedOneTimes, oneTimesGrid, initOneTimesGrid);
	                        tabCacher.loadedOneTimes = true;
	                        break;
	                    case "#ContentACHSavingsGoals":
	                        tabCacher.loadTab(tabCacher.loadedGoals, goalsGrid, initGoalsGrid);
	                        tabCacher.loadedGoals = true;
	                        break;
	                    case "#ContentTransactions":
	                        tabCacher.loadTab(tabCacher.loadedTransactions, transGrid, initTransGrid);
	                        tabCacher.loadedTransactions = true;
	                        break;
	                }
	            });

	            //one times
	            accountSummaryController.oneTimesGrid = CreateJohnGrid();
	            var oneTimesGrid = accountSummaryController.oneTimesGrid;
	            function initOneTimesGrid() {
	                var tblOneTimes = $("#tblOneTimes"),
                        statusHeaderTxt = 'Status&nbsp;' +
                                          '<a href="#statusInfo" class="info"><img src="https://adestinn2blob.blob.core.windows.net/images/ico-question.png" alt="what\'s this" /></a>' +
                                          '<div id="statusInfo" style="display:none;padding:10px;width:200px;">' +
                                            '<p>' +
                                                '<strong>Pending:</strong> hasn\'t been sent to be processed at the bank, yet<br /><br />' +
                                                '<strong>Submitted:</strong> has been submitted to the bankank<br /><br />' +
                                                '<strong>Reconciled:</strong> has been processed successfully and can be seen on the transactions tab<br /><br />' +
                                                '<strong>Failed:</strong> something went wrong while processing. e.g. insufficient funds, incorrect banking information, etc.' +
                                            '</p>' +
                                        '</div>',
                        oneTimeColumns = [{ DataField: "Amount" },
                                          { DataField: "Name", HeaderText: "Type" },
                                          { DataField: "Status", HeaderText: statusHeaderTxt },
                                          { DataField: "AccountNumber4", HeaderText: "Account" },
                                          { DataField: "EventDate", HeaderText: "Event Date" }];

	                oneTimesGrid.sorting.allowSorting = true;
	                oneTimesGrid.dsPostValues.sortClause = "EventDate DESC";
	                oneTimesGrid.init(tblOneTimes, oneTimeColumns, "oneTimesAJAX.aspx");
	                $(".johnGridHeader", oneTimesGrid.$table).prepend($("#oneTimeFilters"));
	                $("#ddlFilterOneTimes").on("change", function () {
	                    oneTimesGrid.dsPostValues.filter = $(this).val();
	                    oneTimesGrid.databind();
	                });

	                $("a.info").fancybox({
	                    autoSize: true
	                });
	            }

	            //goals
	            accountSummaryController.goalsGrid = CreateJohnGrid();
	            var goalsGrid = accountSummaryController.goalsGrid,
                    goalFilters = $("#goalFilters"),
                    chkMoreInfo = $("#chkMoreInfo");

	            CookieUtil.get("ShowMoreInfo") == null ? chkMoreInfo.prop('checked', false) : chkMoreInfo.prop('checked', true);

	            function initGoalsGrid() {
	                var showMoreInfo = chkMoreInfo.is(":checked");

	                //update cookie
	                var eDate = CookieUtil.expireDate(300),
                        domain = ServerData.isProd ? "adestinn.com" : undefined;
	                showMoreInfo ? CookieUtil.set("ShowMoreInfo", "yep", eDate, "/", domain) : CookieUtil.unset("ShowMoreInfo", "/", domain);
	                var tblGoals = $("#tblGoals"),
                        statusHeaderTxt = 'Status&nbsp;' +
                                          '<a href="#goalStatusInfo" class="infoLink" data-track="AccountSummary,PerfectSaverGoals,StatusHelp,1"><img src="https://adestinn2blob.blob.core.windows.net/images/ico-question.png" alt="what\'s this" /></a>' +
                                          '<div id="goalStatusInfo" style="display:none;padding:10px;width:200px;">' +
                                            '<p>' +
                                                '<strong>Active:</strong> multi-payment goal that is incomplete<br /><br />' +
                                                '<strong>Active (Pending):</strong> single-payment goal hasn\'t been sent to be processed at the bank, yet<br /><br />' +
                                                '<strong>Active (Submitted):</strong> single-payment goal that has been submitted to the bank<br /><br />' +
                                                '<strong>Complete:</strong> all payments required for the goal have been processed successfully<br /><br />' +
                                                '<strong>Canceled:</strong> the goal has been stopped<br /><br />' +
                                                '<strong>Failed:</strong> something went wrong while processing. e.g. insufficient funds, incorrect banking information, etc.' +
                                            '</p>' +
                                        '</div>',
                        goalsColumns = [{ DataField: "Amount", HeaderText: "Goal" },
                                        { DataField: "SavingsDate", HeaderText: "Goal Date" },
                                        { DataField: "TypeName", HeaderText: "Type" },
                                        { DataField: "SavingsApplied", HeaderText: "Amount Applied" },
                                        { DataField: "MonthlyPayment", HeaderText: PaymentType.charAt(0).toUpperCase() + PaymentType.slice(1) + " Amount" },
                                        { DataField: "ACHCount", HeaderText: "Remaining Events" },
                                        { DataField: "Status", HeaderText: statusHeaderTxt },
                                        { DataField: "CreateDate", HeaderText: "Created", Hide: !showMoreInfo },
                                        { DataField: "CancelDate", HeaderText: "Canceled", Hide: !showMoreInfo },
                                        { DataField: "CancelDescription", HeaderText: "Cancel Description", Hide: !showMoreInfo },
                                        { DataField: "VacationName", HeaderText: "Vacation", Hide: !showMoreInfo },
                                        { DataField: "AccountNumber4", HeaderText: "Account", Hide: !showMoreInfo }],
                        goalsURL = "goalsAJAX.aspx";

	                goalsGrid.sorting.allowSorting = true;
	                goalsGrid.dsPostValues.sortClause = "CreateDate";
	                goalsColumns = $.grep(goalsColumns, function (column) { return column.Hide == undefined || !column.Hide });
	                goalsGrid.init(tblGoals, goalsColumns, goalsURL);
	                setGoalsTableStyle(showMoreInfo);

	                $(".johnGridHeader", goalsGrid.$table).prepend(goalFilters);
	                $("#ddlFilterGoals").off("change").on("change", function () {
	                    var filter = $(this).val();
	                    goalsGrid.dsPostValues.filter = filter;
	                    goalsGrid.databind();
	                    window.gaTrack('AccountSummary', 'PerfectSaverGoals', 'Show_' + filter);
	                });
	                goalsGrid.dsPostValues.filter = $("#ddlFilterGoals option:selected").val();

	                chkMoreInfo.off("change").on("change", function () {
	                    initGoalsGrid();
	                    var checked = chkMoreInfo.is(":checked");
	                    setGoalsTableStyle(checked);
	                    goalsGrid.databind();
	                    window.gaTrack('AccountSummary', 'PerfectSaverGoals', 'SeeMoreDetails', checked);
	                });
	            }

	            function setGoalsTableStyle(showingMore) {
	                goalsGrid.$table.css("font-size", showingMore ? "11px" : "12px");
	            }

	            //transactions
	            accountSummaryController.transGrid = CreateJohnGrid();
	            var transGrid = accountSummaryController.transGrid;
                
	            function initTransGrid() {
	                var tblTransactions = $("#tblTransactions"),
                        transColumns = [
                                        {
                                            DataField: "TransactionDate",
                                            HeaderText: "Occurred",
                                            SubGrid:
                                            [
                                                { DataField: "Type", Width: 424 },
                                                { DataField: "Debit", Width: 110 },
                                                { DataField: "Credit" }
                                            ]
                                        },
                                        { DataField: "Description" },
                                        { DataField: "Debit" },
                                        { DataField: "Credit" },
                                        { DataField: 'Balance' }];
	                transGrid.init(tblTransactions, transColumns, "transactionsAJAX.aspx");
	                $(".johnGridHeader", transGrid.$table).prepend($("#transactionFilter"));
	                $("[data-column='Description']", tblTransactions).parent().css("width", "300px"); //slim description column

	                //date range
	                var callCount = 0;
	                Utilities.generalDateRangePicker('#transactionsDateRange', function (start, end) {
	                    callCount++;
	                    if (callCount === 1) {
	                        return; //when we load the tab, databind is called, so skip the first call to this...
	                    }
	                    transGrid.dsPostValues.timeFilter = Utilities.getTimeFilter(start, end);
	                    transGrid.databind();
	                }, {
	                    opens: 'right',
	                    ranges: {
	                        'All Time': [Date.parse("1/1/1900"), Date.today()],
	                        'This Year': [Date.parse("1/1/" + Date.today().getFullYear()), Date.today()],
	                        'Last 30 Days': [Date.today().add({ days: -29 }), 'today'],
	                        'Last 90 Days': [Date.today().add({ days: -90 }), 'today']
	                    }
	                }, {
	                    End: Date.today(),
	                    Start: Date.today().add({ days: -90 })
	                });
	            }

	            accountSummaryController.balancesGrid = CreateJohnGrid();
	            var balancesGrid = accountSummaryController.balancesGrid,
                    tblBalancesAndCommitted = $("#tblBalancesAndCommitted"),
                    balancesColumns = [{ DataField: "Name", HeaderText: "Type" },
                                       { DataField: "VSA", HeaderText: "Vacation Savings Account" },
                                       { DataField: "Committed", HeaderText: "Committed To Vacationing" }];

	            balancesGrid.init(tblBalancesAndCommitted, balancesColumns, "balancesAJAX.aspx");
	            balancesGrid.databind();

	            if (requestQueryString("t") == "ps") {
	                initGoalsGrid();
	                goalsGrid.databind();
	            }
	        }

	        return layout.initStatic('/fe/templates/member/accountsummary').then(init);
	    },
        unload: function() {
            $('form').off('submit');
            $('#account_tabs a').off('click');
            $("#ddlFilterOneTimes").off("change");
            $("#ddlFilterGoals").off("change");
            $("#chkMoreInfo").off("change");
            this._destroyGrid(accountSummaryController.transGrid);
            this._destroyGrid(accountSummaryController.balancesGrid);
            this._destroyGrid(accountSummaryController.goalsGrid);
            this._destroyGrid(accountSummaryController.oneTimesGrid);
        },

        _destroyGrid: function(grid) {
            if (grid != null) {
                grid.unload();
            }
        }
	};
    return accountSummaryController;
});
